import React, { useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { AppContext, DispatchContext } from "../AppContext";
import * as actions from "../actions/actions";
import Service from "../services/service";
import CircularProgress from '@material-ui/core/CircularProgress';

export default function Checkout(props) {

  const useStyles = makeStyles((theme) => ({
    root: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      height: "100vh",
      background: theme.palette.background.image,
      backgroundSize: "cover",
      padding: theme.spacing(2),
      justifyContent: "center",
      alignItems: "center",
      color: "white"
    }
  }));

  const dispatch = useContext(DispatchContext);
  const state = useContext(AppContext);
  const classes = useStyles();
  const { id } = useParams();

  useEffect(() => {
    Service.getPaymentStatus(id).then((res) => {
      if (res.success) {
        if (res.data.uploadId) {
          if (res.data.status == "paid") {
            dispatch(actions.setCheckoutDetails({ wizard: { step: 10, uploadId: res.data.uploadId }, invoiceId: id, paymentStatus: res.data.status, paid: res.data.paid }));
            dispatch(actions.navigate_to("/wizard"));
          } else {
            dispatch(actions.setUI({ paymentDialogVisible: true })); // don't use OpenPaymentDialog() to prevent resetting checkout fields
            dispatch(actions.setCheckoutDetails({ paymentStep: (res.data.status == "pending" || res.data.status == "open" || res.data.status == "paid") ? 5 : 4, invoiceId: id, paymentStatus: res.data.status, paid: res.data.paid }));
            dispatch(actions.navigate_to("/"));
          }
        } else {
          // go to final payment step in case the invoice is either fully paid or pending fulfillment
          // other states (canceled, authorized, expired, failed) will be routed to payment selection 
          dispatch(actions.setUI({ paymentDialogVisible: true })); // don't use OpenPaymentDialog() to prevent resetting checkout fields
          dispatch(actions.setCheckoutDetails({ paymentStep: (res.data.status == "pending" || res.data.status == "open" || res.data.status == "paid") ? 5 : 4, invoiceId: id, paymentStatus: res.data.status, paid: res.data.paid }));
          dispatch(actions.navigate_to("/"));
        }
      } else {
        dispatch(actions.navigate_to("/"));
        dispatch(actions.openToast({ type: "error", message: res.errors[0], status: true }));
      }
    });
  }, []);


  return (
    <div className={classes.root}>
      <CircularProgress color="inherit" />
    </div>);
}
